import React, { FC } from 'react';
import {
  Skeleton,
  SkeletonLine,
  SkeletonContent,
  SkeletonBlock
} from '@one-thd/sui-atomic-components';

interface ILoader {
  rows?: number;
}

const LoaderListPod = () => {
  return (
    <Skeleton orientation="horizontal">
      <SkeletonContent disablePadding initialSize="2/4">
        <SkeletonBlock aspect="wide" />
      </SkeletonContent>
      <SkeletonContent initialSize="2/4">
        <SkeletonLine variant="single" />
      </SkeletonContent>
    </Skeleton>
  );
};

const LoaderListWrapper: FC<ILoader> = ({ rows }) => {
  return (
    <div
      className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 sui-gap-4
        lg:sui-grid-cols-3 sui-gap-8"
      data-testid="gc-list-loader"
    >
      {new Array(rows || 9).fill('').map((value, i) => (
        <LoaderListPod key={`row-${i}`} />
      ))}
    </div>
  );
};

const ListLoader: FC<ILoader> = ({ rows }) => {
  return <LoaderListWrapper rows={rows} />;
};

export default ListLoader;
